export enum QUERYKEYS {
  VERIFY_CODE = "verify-code",
  SIGN_UP = "sign-up",
  SIGN_IN = "sign-in",
  USER = "user",
  LOGOUT = "logout",
  EDIT_USER = "edit-user",
  NOTIFICATIONS = "notifications",
  MARK_READ_NOTIFICATION = "mark-read-nootification",
  EVENTS = "events",
  CREATE_EVENT = "create-event",
  EVENT = "event",
  FAVORITE_EVENTS = "favorite-events",
  DELETE_FAVORITE = "delete-favorite",
  SAVE_FAVORITE = "save-favorite",
  USER_EVENTS = "user-events",
  REFERRALS = "referrals",
  PROMO_CODE = "promo-code",
  APPLY_PROMO_CODE = "apply-promo-code",
  USER_STATISTICS = "user-statistics",
  BETS_HISTORY = "bets-history",
  CURRENT_BETS = "current-bets",
  EVENTS_FILTER = "events-filter",
  CREATE_BET = "create-bet",
  BETS_VOLUME = "bets-volume",
  CHARTS_EVENTS = "charts-events",
  FORGET_PASSWORD = "forget-password",
  SEND_RESET_CODE = "send-reset-code",
  RESET_PASSWORD = "reset-password",
  SUPPORTED_CURRENCIES = "supported-currencies",
  WALLETS = "wallets",
  CREATE_WALLET = "create-wallet",
  CREATE_WITHDRAWAL = "create-withdrawal",
  DEPOSIT_HISTORY = "deposit-history",
  WITHDRAWAL_HISTORY = "withdrawal-history",
  EXCHANGE_RATES = "exchange-rates",
  SOCIAL_LINKS = "social-links",
  WAGERING_STATUS = "wagering-status",
}
